import { Helmet } from '@dr.pogodin/react-helmet';
import { forwardRef, type ReactNode } from 'react';
// material
import { Box } from '@mui/material';
import { useBrandText } from 'src/contexts/BrandContext';

// ----------------------------------------------------------------------

type PageProps = Omit<React.ComponentProps<typeof Box>, 'ref' | 'title'> & {
  children?: ReactNode;
  title?: string;
};

const Page = forwardRef<HTMLDivElement, PageProps>(function PageImpl(
  { children, title = '', ...other },
  ref
) {
  const getBrandText = useBrandText();
  const brandedTitle = getBrandText(title);

  return (
    <Box ref={ref} {...other}>
      <Helmet>{brandedTitle ? <title>{brandedTitle}</title> : null}</Helmet>
      {children}
    </Box>
  );
});

export default Page;
